import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import { TargetData } from "../types";

interface EquipmentCardProps {
  selectedTarget: TargetData;
}

const EquipmentCard: React.FC<EquipmentCardProps> = ({ selectedTarget }) => {
  if (!selectedTarget.equipment) {
    return <Typography color="error">No equipment info available</Typography>;
  }
  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        borderRadius: 3,
        boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
        p: 3,
        border: "1px solid",
        borderColor: "divider",
        minHeight: 340,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        flex: 1,
        height: "100%",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 700,
          mb: 2,
          display: "flex",
          alignItems: "center",
          color: "primary.main",
        }}
      >
        <span style={{ marginRight: 8 }}>🛠️</span> Equipment
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
        <Typography color="text.secondary">Telescope</Typography>
        <Box fontWeight={600} component="span">
          {selectedTarget.equipment.telescopeName}
        </Box>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
        <Typography color="text.secondary">Focal Length</Typography>
        <Box fontWeight={600} component="span">
          {selectedTarget.equipment.focalLength}
        </Box>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
        <Typography color="text.secondary">Focal Ratio</Typography>
        <Box fontWeight={600} component="span">
          {selectedTarget.equipment.focalRatio}
        </Box>
      </Box>
      <Divider sx={{ my: 1.5, bgcolor: "divider" }} />
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
        <Typography color="text.secondary">Camera</Typography>
        <Box fontWeight={600} component="span">
          {selectedTarget.equipment.cameraName}
        </Box>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
        <Typography color="text.secondary">Pixel Size</Typography>
        <Box fontWeight={600} component="span">
          {selectedTarget.equipment.pixelSize}
        </Box>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography color="text.secondary">Bit Depth</Typography>
        <Box fontWeight={600} component="span">
          {selectedTarget.equipment.bitDepth}
        </Box>
      </Box>
    </Box>
  );
};

export default EquipmentCard;
